import React from 'react';
import { Label } from 'semantic-ui-react';


const LabelWarning = ({ show }) => {
    return (
        show
            ?<Label color='red' pointing>Preencha este campo</Label>
            :null
    );
};

export default LabelWarning;